<template>
  <v-card outlined tile class="ma-3 pa-0">
    <v-card tile class="d-flex justify-start align-center">
      <v-card tile class="pl-3 pb-3 elevation-0" width="250px">
        <v-chip color="primary">ГОСТ</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3 elevation-0" width="400px">
        <ws-g-o-s-t-selector :f-t_-i-d="'-5'" :set-global-filter="false" :as-filter="false" v-model="GOST" :readonly="mode=='viewer'"></ws-g-o-s-t-selector>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start align-center mt-2">
      <v-card tile class="pl-3 pr-3 elevation-0" width="250px">
        <v-chip color="primary">ОКПД</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="OKPD" dense readonly >
          <template v-slot:append v-if="mode=='editor'">
            <v-icon small @click="callSelectOKPD"> mdi-plus-circle-multiple-outline </v-icon>
          </template>
        </v-text-field>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start align-center">
      <v-card tile class="pl-3 pr-3 elevation-0" width="250px">
        <v-chip color="primary">Заводское наименование</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="GRADE_NAME" dense :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start align-center">
      <v-card tile class="pl-3 pr-3 elevation-0" width="250px">
        <v-chip color="primary">Заводской код</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="GRADE_CODE" dense :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <select-fuel-type-dialog :o-k-e-i="OKPD" :dialog="showSelectOKPD" @onCloseDialog="closeOKPDSelectDialog" @onSelectFT="setOKPD"></select-fuel-type-dialog>
  </v-card>
</template>

<script>
import WsGOSTSelector from '@/components/modules/projects/ui/wsGOSTSelector'
import SelectFuelTypeDialog from '@/components/modules/projects/dialogs/selectFuelTypeDialog'
export default {
  name: 'refFuelGradeCard',
  components: { SelectFuelTypeDialog, WsGOSTSelector },
  props: ['grade', 'mode'],
  data () {
    return {
      showSelectOKPD: false
    }
  },
  computed: {
    GRADE_NAME: {
      get () {
        return this.grade ? this.grade.GRADE_NAME : ''
      },
      set (val) {
        this.$emit('onGradeUpdate', { GRADE_NAME: val })
      }
    },
    GRADE_CODE: {
      get: function () {
        return this.grade ? this.grade.GRADE_CODE : ''
      },
      set (val) {
        this.$emit('onGradeUpdate', { GRADE_CODE: val })
      }
    },
    GOST: {
      get: function () {
        return this.grade ? this.grade.GOST : null
      },
      set (val) {
        this.$emit('onGradeUpdate', { GOST: val })
      }
    },
    OKPD: {
      get: function () {
        const retVal = this.grade ? this.grade.OKPD ? this.grade.OKPD.OKPD_ID : 'нет' : 'нет'
        return retVal
      },
      set (val) {
        this.$emit('onGradeUpdate', { OKPD: val })
        this.GRADE_NAME = val ? val.OKPD_NAME : this.GRADE_NAME ? this.GRADE_NAME : ''
      }
    }
  },
  methods: {
    callSelectOKPD () {
      this.showSelectOKPD = true
    },
    closeOKPDSelectDialog () {
      this.showSelectOKPD = false
    },
    setOKPD (val) {
      console.log('Setting OKPD to ', val)
      this.OKPD = val
      this.showSelectOKPD = false
    }
  },
  mounted () {
    console.log('refFuelGradeCard mounted in mode ', this.mode, ' with grade ', this.grade)
  }
}
</script>
